<small class="form-text invalid-feedback" [ngClass]="control.invalid && (control.dirty || control.touched) ? 'd-block d-flex' : 'd-none'">
  <span class="material-icons-round icon-sm mt-0">error_outline</span>
  <span class="align-self-center ps-1" [innerHTML]="errorMessage"></span>
</small>
